import { render } from "./Index.vue?vue&type=template&id=681b01db&scoped=true"
import script from "./Index.vue?vue&type=script&scoped=true&lang=js"
export * from "./Index.vue?vue&type=script&scoped=true&lang=js"

import "./Index.vue?vue&type=style&index=0&id=681b01db&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vizbi-frontend-test/vizbi-frontend-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681b01db"]])

export default __exports__